import React from 'react';

interface IconFlashProps {
  className?: string;
  color?: string;
  size?: number;
}

const IconFlash: React.FC<IconFlashProps> = ({ className = '', color, size = 24 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <path
        d="M9.99496 22.7784C9.79496 22.7784 9.63496 22.7384 9.51496 22.6884C9.11496 22.5384 8.43496 22.0484 8.43496 20.4984V14.0484H6.09496C4.75496 14.0484 4.27496 13.4184 4.10496 13.0484C3.93496 12.6684 3.78496 11.8984 4.66496 10.8884L12.235 2.28845C13.255 1.12845 14.085 1.20845 14.485 1.35845C14.885 1.50845 15.565 1.99845 15.565 3.54845V9.99845H17.905C19.245 9.99845 19.725 10.6284 19.895 10.9984C20.065 11.3784 20.215 12.1484 19.335 13.1584L11.765 21.7584C11.055 22.5684 10.435 22.7784 9.99496 22.7784ZM13.935 2.76845C13.905 2.80845 13.695 2.90845 13.365 3.28845L5.79496 11.8884C5.51496 12.2084 5.47496 12.4084 5.47496 12.4484C5.49496 12.4584 5.67496 12.5584 6.09496 12.5584H9.18496C9.59496 12.5584 9.93496 12.8984 9.93496 13.3084V20.5084C9.93496 21.0084 10.025 21.2284 10.065 21.2884C10.095 21.2484 10.305 21.1484 10.635 20.7684L18.205 12.1684C18.485 11.8484 18.525 11.6484 18.525 11.6084C18.505 11.5984 18.325 11.4984 17.905 11.4984H14.815C14.405 11.4984 14.065 11.1584 14.065 10.7484V3.54845C14.075 3.04845 13.975 2.83845 13.935 2.76845Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default IconFlash;
